// biome-ignore lint/complexity/useArrowFunction: TODO
// biome-ignore lint/style/useConst: TODO
export let stream = { Stream: function () {} };

// biome-ignore lint/complexity/useArrowFunction: TODO
// biome-ignore lint/style/useConst: TODO
export let Stream = function () {};
